import { chartConfig } from "../chart.commonConfig";
import {
  PATHS,
  PDF_CONSTANT,
  ISSUE_STAGES_CENTRAL
} from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";
import { CATEGORY_LIMIT } from "../chartHelper";
import { get } from "lodash";

export const THIRD_PIE_CHART_RESPONSIVE_HELPER = (data, history) => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      //height: 400,
      height: (12 / 16) * 100 + "%",
      animation: {
        duration: 9000
      },
      className: "chart-background second-pie-graph",
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.SECOND._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: "",
      useHTML: true,
      style: { color: "#000000", fontSize: "26px", "font-family": "mpb" },
      verticalAlign: "middle",
      y: 10
    },
    plotOptions: {
      series: {
        animation: true,
        duration: 9000
      },
      pie: {
        allowPointSelect: true,
        shadow: true,
        dataLabels: {
          enabled: true,
          //alignTo: "plotEdges",
          distance: -30,
          style: {
            color: "white"
          },
          className: "data-label-text"
        },
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            },
            click: function(event) {
              history.push({
                pathname: PATHS.ISSUE_LIST,
                isDashBoard: true,
                summaryDataBy: false,
                state: {
                  category: [
                    {
                      displayName: this.name,
                      key: this.categoryId
                    }
                  ],
                  projectStage: [
                    {
                      key: "VERIFIED",
                      displayName: "Verified"
                    }
                  ],
                  groupCategory: "CENTRAL",
                  stages: ISSUE_STAGES_CENTRAL
                }
              });
            }
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        // colorByPoint: true,
        data: [],
        startAngle: 90,
        size: "100%",
        innerSize: "50%",
        //depth: 50,
        dataLabels: {
          enabled: true,
          alignTo: "connectors",
          format: `<span style="color:{point.color}">{point.y}</span>`
        }
      }
    ],
    legend: {
      enabled: false,
      align: "left",
      verticalAlign: "bottom",
      layout: "horizontal",
      floating: true,
      symbolHeight: 8,
      symbolWidth: 8,
      symbolRadius: 4,
      padding: 1,
      itemMarginTop: 0,
      itemMarginBottom: 1,
      //itemWidth: 200,
      margin: 1,
      itemStyle: {
        lineHeight: "17px",
        color: "#2E384D",
        "font-family": "mpr",
        fontSize: "11px",
        fontWeight: "300",
        textOverflow: "clip"
      }
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Issues: ${this.y}</b>
              `;
      }
    }
    /*responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 990
                    },
                    chartOptions: {
                        legend: {
                            enabled: false,
                            align: "left",
                            verticalAlign: "bottom",
                            layout: "horizontal",
                            floating: false,
                            alignColumns: false,
                            symbolHeight: 10,
                            symbolWidth: 10,
                            symbolRadius: 4,
                            padding: 2,
                            itemMarginTop: 0,
                            itemMarginBottom: 3,
                            itemWidth: 100,
                            margin: 20,
                            itemStyle: {
                                lineHeight: "18px",
                                color: "#2E384D",
                                "font-family": "mpr",
                                fontSize: "14px",
                                fontWeight: "300",
                                textOverflow: "clip"
                            }
                        },
                        title: {
                            align: "center"
                        }
                    }
                }
            ]
        }*/
  };

  try {
    // set data
    let totalIssuesCount = 0;
    PieChartConfig.series[0]["data"] = (data || []).map((val, index) => {
      totalIssuesCount = totalIssuesCount + val.issuesCount;
      return {
        name: val.category,
        y: val.issuesCount,
        categoryId: val.categoryId
      };
    });
    //PieChartConfig.title.text = `SECTOR DISTRIBUTION : ${totalProjects} PROJECTS`;
    //PieChartConfig.title.text = `${totalProjects}`;
    PieChartConfig.title.text = `${totalIssuesCount}`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
